import { createFileRoute } from '@tanstack/react-router';

import { TotalsPage } from '@/features/logbook';

export const Route = createFileRoute('/logbook/totals')({
  component: TotalsPage,
});
